(function () {
    'use strict';

    angular.module('app.core').config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('signin', {
                url: '/:langcode/signin?status?info?type?code?email',
                templateUrl: 'app/security/auth-signin/auth-signin.html',
                controller: 'SignInController',
                params: {
                    langcode: {
                        value: ['$translate', function ($translate) {
                            return $translate.use();
                        }]
                    },
                    info: null,
                    type: null
                },
                resolve: {
                    lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                        return lazyLoadSvc.load($transition$, 'securityExternal');
                    }],
                    title: ['$translate', function ($translate) {
                        return $translate('c_signin').then(function (res) {
                            return res;
                        });
                    }],
                    description: ['$translate', function ($translate) {
                        return $translate('c_signin_desc').then(function (res) {
                            return res;
                        });
                    }],
                    redirectIfLogin: ['$q', 'userSvc', 'restoreUrlService', '$transition$', function ($q, userSvc, restoreUrlService, $transition$) {
                        var deferrer = $q.defer();
                        userSvc.getUserInfo().then(function () {
                            if (userSvc.info.SignedIn && !$transition$.params().info && $transition$.params().status !== 'guard') {
                                $transition$.abort();
                                restoreUrlService.returnTo();
                            }
                            else
                                deferrer.resolve();
                        }, function () {
                            deferrer.resolve();
                        });
                        return deferrer.promise;
                    }]
                },
                metaTags: {
                    title: '{{title}}',
                    robots: 'noindex, nofollow',
                    description: '{{description}}',
                    properties: {
                        'og:image': 'http://www.endeksa.com/share3.jpg',
                        'og:image:secure_url': 'https://www.endeksa.com/share3.jpg',
                        'og:type': 'website'
                    }
                }
            })

            .state('code', {
                url: '/:langcode/signin/code?code',
                templateUrl: 'app/security/auth-two-factor/auth-two-factor.html',
                controller: 'TwoFactorController',
                params: {
                    langcode: {
                        value: ['$translate', function ($translate) {
                            return $translate.use();
                        }]
                    }
                },
                resolve: {
                    lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                        return lazyLoadSvc.load($transition$, 'security');
                    }],
                    redirectIfLogin: ['$q', 'userSvc', 'restoreUrlService', '$transition$', function ($q, userSvc, restoreUrlService, $transition$) {
                        var deferrer = $q.defer();
                        userSvc.getUserInfo().then(function () {
                            if (userSvc.info.SignedIn && !$transition$.params().info && $transition$.params().status !== 'guard') {
                                $transition$.abort();
                                restoreUrlService.returnTo();
                            }
                            else
                                deferrer.resolve();
                        }, function () {
                            deferrer.resolve();
                        });
                        return deferrer.promise;
                    }]
                },
                metaTags: {
                    robots: 'noindex, nofollow'
                }
            })

            .state('unblock', {
                url: '/:langcode/unblockuser?token&email',
                templateUrl: 'app/security/auth-unblock-user/auth-unblock-user.html',
                controller: 'UnblockUserController',
                params: {
                    langcode: {
                        value: ['$translate', function ($translate) {
                            return $translate.use();
                        }]
                    }
                },
                resolve: {
                    lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                        return lazyLoadSvc.load($transition$, 'security');
                    }]
                },
                metaTags: {
                    robots: 'noindex, nofollow'
                }
            })

            .state('register', {
                url: '/:langcode/register',
                templateUrl: 'app/security/auth-register/auth-register.html',
                controller: 'RegisterController',
                params: {
                    langcode: {
                        value: ['$translate', function ($translate) {
                            return $translate.use();
                        }]
                    }
                },
                resolve: {
                    lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                        return lazyLoadSvc.load($transition$, 'securityExternal');
                    }],
                    title: ['$translate', function ($translate) {
                        return $translate('c_register').then(function (res) {
                            return res;
                        });
                    }],
                    description: ['$translate', function ($translate) {
                        return $translate('c_register_desc').then(function (res) {
                            return res;
                        });
                    }],
                    redirectIfLogin: ['$q', 'userSvc', 'restoreUrlService', '$transition$', function ($q, userSvc, restoreUrlService, $transition$) {
                        var deferrer = $q.defer();
                        userSvc.getUserInfo().then(function () {
                            if (userSvc.info.SignedIn && !$transition$.params().info) {
                                $transition$.abort();
                                restoreUrlService.returnTo();
                            }
                            else
                                deferrer.resolve();
                        }, function () {
                            deferrer.resolve();
                        });
                        return deferrer.promise;
                    }],
                    //
                    // translations: function ($translatePartialLoader, $translate) {
                    //     $translatePartialLoader.addPart("contract_agreement");
                    //     return $translate.refresh();
                    // }
                },
                metaTags: {
                    title: '{{title}}',
                    robots: 'noindex, nofollow',
                    description: '{{description}}',
                    properties: {
                        'og:image': 'http://www.endeksa.com/share3.jpg',
                        'og:image:secure_url': 'https://www.endeksa.com/share3.jpg',
                        'og:type': 'website'
                    }
                }
            })

            .state('confirmEmail', {
                url: '/:langcode/confirm?email',
                templateUrl: 'app/security/auth-confirm-email/auth-confirm-email.html',
                controller: 'ConfirmEmailController',
                params: {
                    langcode: {
                        value: ['$translate', function ($translate) {
                            return $translate.use();
                        }]
                    }
                },
                resolve: {
                    lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                        return lazyLoadSvc.load($transition$, 'security');
                    }]
                },
                metaTags: {
                    robots: 'noindex, nofollow'
                }
            })

            .state('activateEmail', {
                url: '/:langcode/activation?email',
                templateUrl: 'app/security/auth-activate-email/auth-activate-email.html',
                controller: 'ActivateEmailController',
                params: {
                    langcode: {
                        value: ['$translate', function ($translate) {
                            return $translate.use();
                        }]
                    }
                },
                resolve: {
                    lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                        return lazyLoadSvc.load($transition$, 'security');
                    }]
                },
                metaTags: {
                    robots: 'noindex, nofollow'
                }
            })

            .state('forgotPassword', {
                url: '/:langcode/forgot',
                templateUrl: 'app/security/auth-forgot-password/auth-forgot-password.html',
                controller: 'ForgotPasswordController',
                params: {
                    langcode: {
                        value: ['$translate', function ($translate) {
                            return $translate.use();
                        }]
                    }
                },
                resolve: {
                    lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                        return lazyLoadSvc.load($transition$, 'security');
                    }]
                },
                metaTags: {
                    robots: 'noindex, nofollow'
                }
            })

            .state('resetPassword', {
                url: '/:langcode/resetpassword?key?email?token',
                templateUrl: 'app/security/auth-reset-password/auth-reset-password.html',
                controller: 'ResetPasswordController',
                params: {
                    langcode: {
                        value: ['$translate', function ($translate) {
                            return $translate.use();
                        }]
                    },
                    token: null,
                    email: null,
                    key: null
                },
                resolve: {
                    lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                        return lazyLoadSvc.load($transition$, 'security');
                    }]
                },
                metaTags: {
                    robots: 'noindex, nofollow'
                }
            })

            .state('newPassword', {
                url: '/:langcode/createpassword?token?email?key',
                templateUrl: 'app/security/auth-new-password/auth-new-password.html',
                controller: 'NewPasswordController',
                params: {
                    langcode: {
                        value: ['$translate', function ($translate) {
                            return $translate.use();
                        }]
                    },
                    token: null,
                    email: null,
                    key: null
                },
                resolve: {
                    lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                        return lazyLoadSvc.load($transition$, 'security');
                    }]
                },
                // Additional resolves can be added here: {
                //
                // translations: function ($translatePartialLoader, $translate) {
                //     $translatePartialLoader.addPart("contract_agreement");
                //     return $translate.refresh();
                // }
                // },
                metaTags: {
                    robots: 'noindex, nofollow'
                }
            })
            .state('externalauth', {
                url: '/externalauth/:function'
            }).state('confirmuser', {
                url: '/:langcode/confirmuser',
                params: {
                    langcode: { squash: true, value: null },
                }
            }).state('renew', {
                url: '/resetpassword'
            }).state('sso', {
                url: '/:langcode/sso/:guid',
                params: {
                    langcode: {
                        value: ['$translate', function ($translate) {
                            return $translate.use();
                        }]
                    },
                    guid: null
                },
                resolve: {
                    verify: ['auth_factory', '$transition$', 'restoreUrlService', '$window', 'notifierSvc', '$translate', 'CacheFactory', 'userSvc',
                        function (auth_factory, $transition$, restoreUrlService, $window, notifierSvc, $translate, CacheFactory, userSvc) {
                            auth_factory.verify_partner_login({ VerificationToken: $transition$.params().guid })
                                .$promise.then(function (result) {
                                    $window.localStorage.setItem('accessToken', result.accessToken);
                                    $window.localStorage.setItem('accessTokenExpires', result.accessTokenExpiration);
                                    $window.localStorage.setItem('refreshToken', result.refreshToken);
                                    $window.localStorage.setItem('refreshTokenExpires', result.refreshTokenExpiration);
                                    CacheFactory.get('UserCache') && CacheFactory.get('UserCache').removeAll();
                                    CacheFactory.get('UserInfo') && CacheFactory.get('UserInfo').removeAll();
                                    userSvc.getUserInfo().then((res) => {
                                        restoreUrlService.returnTo(true);
                                    });

                                }, function () {
                                    notifierSvc.show({ message: $translate.instant('sso_error'), type: 'error' });
                                    $transition$.router.stateService.go('signin', { langcode: window.lang });
                                });
                        }]
                }
            });
    }]);
})();
